<div [class.calendar-div]="calendarOptionsOpened" class="date-range">
  <div class="hotspot-area"
       tabindex="0"
       (keydown)="keyPressed($event, 'toggleCalendar', ['Tab', 'Shift', 'Control', 'Alt'])"
       (click)="toggleCalendar()">
  </div>

  <div class="flex" role="button" aria-label="Toggle" (click)="toggleCalendar()">
    <div class="date-range-label"
         [class.placeholder]="!dateFrom && !dateTo">
      <span>{{dateRangeLabel}}</span>
    </div>
  </div>

  <div class="cursor-pointer"
       role="button"
       aria-label="Toggle"
       [class.opened]="calendarOptionsOpened"
       (click)="toggleCalendar()">
    <div class="arrow"></div>
  </div>

  <div *ngIf="calendarOptionsOpened" class="calendars" [class.default-today-highlight]="!dateFrom && !dateTo"  cdkTrapFocus>
    <div class="months-pickers">
      <p-datepicker [(ngModel)]="dateFromUTC" 
      (onSelect)="onPickerDateChange('from', $event)" 
      [inline]="true"
                  [showTime]="false" 
                  [locale]="locales[lang]"
                  wcag-label
                  view="date"
                  yearRange="2000:2030">
      </p-datepicker>
      <p-datepicker [(ngModel)]="dateToUTC" 
      (onSelect)="onPickerDateChange('to', $event)" [inline]="true"
                  [showTime]="false" 
                  [locale]="locales[lang]"
                  wcag-label
                  view="date"
                  [minDate]="dateFromUTC"
                  yearRange="2000:2030">
      </p-datepicker>
      <div class="buttons-wrapper">
        <p-selectButton appFixSelectButtonAria
          (onChange)="onChangedDateOption($event)" [(ngModel)]="selectedDateOption" [options]="dateOptions">
        </p-selectButton>
      </div>

    </div>
  </div>

</div>
